export interface Contract {
  id: string
  title: string
  supplierId: string
  supplierName: string
  type:
    | 'master-agreement'
    | 'purchase-agreement'
    | 'service-agreement'
    | 'nda'
    | 'amendment'
  status:
    | 'draft'
    | 'internal-review'
    | 'supplier-review'
    | 'negotiation'
    | 'pending-signature'
    | 'active'
    | 'expiring-soon'
    | 'expired'
    | 'terminated'
  startDate: string
  endDate: string
  value: number
  currency: string
  owner: string
  department: string
  lastUpdated: string
  version: string
  clauseDeviations: number
  renewalType: 'auto' | 'manual' | 'none'
}

export const contracts: Contract[] = [
  {
    id: 'CTR-2024-001',
    title: 'Master Supply Agreement — Seafood',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    type: 'master-agreement',
    status: 'active',
    startDate: '2024-01-01',
    endDate: '2026-12-31',
    value: 25000000,
    currency: 'SGD',
    owner: 'Rachel Tan',
    department: 'Fresh Procurement',
    lastUpdated: '2025-12-15',
    version: 'v3.2',
    clauseDeviations: 0,
    renewalType: 'manual',
  },
  {
    id: 'CTR-2026-015',
    title: 'Logistics SLA Amendment',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    type: 'amendment',
    status: 'supplier-review',
    startDate: '2026-04-01',
    endDate: '2026-12-31',
    value: 1200000,
    currency: 'SGD',
    owner: 'David Ng',
    department: 'Logistics',
    lastUpdated: '2026-03-10',
    version: 'v1.1',
    clauseDeviations: 2,
    renewalType: 'none',
  },
  {
    id: 'CTR-2026-016',
    title: 'Premium Seafood Supply Agreement',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    type: 'purchase-agreement',
    status: 'pending-signature',
    startDate: '2026-05-01',
    endDate: '2028-04-30',
    value: 8500000,
    currency: 'SGD',
    owner: 'Rachel Tan',
    department: 'Fresh Procurement',
    lastUpdated: '2026-03-14',
    version: 'v2.0-final',
    clauseDeviations: 1,
    renewalType: 'auto',
  },
  {
    id: 'CTR-2023-042',
    title: 'Frozen Seafood Master Agreement',
    supplierId: 'SUP-001',
    supplierName: 'Oceanic Harvest Pte Ltd',
    type: 'master-agreement',
    status: 'expiring-soon',
    startDate: '2023-06-01',
    endDate: '2026-05-31',
    value: 15000000,
    currency: 'SGD',
    owner: 'Rachel Tan',
    department: 'Fresh Procurement',
    lastUpdated: '2025-06-01',
    version: 'v1.0',
    clauseDeviations: 0,
    renewalType: 'manual',
  },
  {
    id: 'CTR-2024-002',
    title: 'Fresh Produce Supply Agreement',
    supplierId: 'SUP-002',
    supplierName: 'Golden Fields Agriculture',
    type: 'purchase-agreement',
    status: 'active',
    startDate: '2024-04-01',
    endDate: '2027-03-31',
    value: 48000000,
    currency: 'SGD',
    owner: 'Rachel Tan',
    department: 'Fresh Procurement',
    lastUpdated: '2025-10-20',
    version: 'v2.1',
    clauseDeviations: 1,
    renewalType: 'auto',
  },
  {
    id: 'CTR-2023-003',
    title: 'Chilled Meats Master Agreement',
    supplierId: 'SUP-003',
    supplierName: 'Pacific Meats International',
    type: 'master-agreement',
    status: 'expiring-soon',
    startDate: '2023-07-01',
    endDate: '2026-06-30',
    value: 90000000,
    currency: 'SGD',
    owner: 'David Ng',
    department: 'Meat & Seafood',
    lastUpdated: '2026-02-28',
    version: 'v4.0',
    clauseDeviations: 2,
    renewalType: 'manual',
  },
  {
    id: 'CTR-2025-004',
    title: 'Private Label Manufacturing Agreement',
    supplierId: 'SUP-005',
    supplierName: 'Evergreen Label Manufacturing',
    type: 'purchase-agreement',
    status: 'negotiation',
    startDate: '2025-01-01',
    endDate: '2027-12-31',
    value: 21600000,
    currency: 'SGD',
    owner: 'Michelle Wong',
    department: 'Private Label',
    lastUpdated: '2026-03-14',
    version: 'v1.4-redline',
    clauseDeviations: 5,
    renewalType: 'manual',
  },
  {
    id: 'CTR-2025-005',
    title: 'Pharmaceutical Distribution Agreement',
    supplierId: 'SUP-006',
    supplierName: 'MedWell Pharma Distribution',
    type: 'service-agreement',
    status: 'active',
    startDate: '2025-03-01',
    endDate: '2028-02-28',
    value: 42000000,
    currency: 'SGD',
    owner: 'Kevin Teo',
    department: 'Pharmacy',
    lastUpdated: '2025-08-10',
    version: 'v2.0',
    clauseDeviations: 0,
    renewalType: 'auto',
  },
  {
    id: 'CTR-2025-006',
    title: 'Cold Chain Logistics Service Agreement',
    supplierId: 'SUP-008',
    supplierName: 'SwiftHaul Logistics',
    type: 'service-agreement',
    status: 'active',
    startDate: '2025-06-01',
    endDate: '2027-05-31',
    value: 12000000,
    currency: 'SGD',
    owner: 'David Ng',
    department: 'Logistics',
    lastUpdated: '2025-11-22',
    version: 'v1.1',
    clauseDeviations: 0,
    renewalType: 'auto',
  },
  {
    id: 'CTR-2026-007',
    title: 'SaaS Platform License Agreement',
    supplierId: 'SUP-009',
    supplierName: 'CloudBridge Technologies',
    type: 'service-agreement',
    status: 'pending-signature',
    startDate: '2026-04-01',
    endDate: '2029-03-31',
    value: 7200000,
    currency: 'SGD',
    owner: 'Jason Ong',
    department: 'Technology',
    lastUpdated: '2026-03-12',
    version: 'v1.0-final',
    clauseDeviations: 0,
    renewalType: 'auto',
  },
  {
    id: 'CTR-2025-008',
    title: 'Dairy Products Supply Agreement',
    supplierId: 'SUP-012',
    supplierName: 'Sunrise Dairy Co-op',
    type: 'purchase-agreement',
    status: 'active',
    startDate: '2025-01-01',
    endDate: '2027-12-31',
    value: 36000000,
    currency: 'SGD',
    owner: 'Rachel Tan',
    department: 'Fresh Procurement',
    lastUpdated: '2025-06-15',
    version: 'v2.0',
    clauseDeviations: 1,
    renewalType: 'manual',
  },
  {
    id: 'CTR-2024-009',
    title: 'FMCG Distribution Agreement',
    supplierId: 'SUP-013',
    supplierName: 'Bintang Raya Foods',
    type: 'purchase-agreement',
    status: 'supplier-review',
    startDate: '2024-06-01',
    endDate: '2026-05-31',
    value: 28500000,
    currency: 'SGD',
    owner: 'Michelle Wong',
    department: 'Packaged Goods',
    lastUpdated: '2026-03-10',
    version: 'v3.1-amendment',
    clauseDeviations: 3,
    renewalType: 'manual',
  },
  {
    id: 'NDA-2026-001',
    title: 'Non-Disclosure Agreement',
    supplierId: 'SUP-014',
    supplierName: 'TechServe Asia',
    type: 'nda',
    status: 'active',
    startDate: '2026-02-01',
    endDate: '2029-01-31',
    value: 0,
    currency: 'SGD',
    owner: 'Jason Ong',
    department: 'Technology',
    lastUpdated: '2026-02-05',
    version: 'v1.0',
    clauseDeviations: 0,
    renewalType: 'none',
  },
]

export function getContractsBySupplier(supplierId: string): Contract[] {
  return contracts.filter((c) => c.supplierId === supplierId)
}

export function getContractById(id: string): Contract | undefined {
  return contracts.find((c) => c.id === id)
}
